import { render, staticRenderFns } from "./client-upload.vue?vue&type=template&id=3a9eb485&"
import script from "./client-upload.vue?vue&type=script&lang=js&"
export * from "./client-upload.vue?vue&type=script&lang=js&"
import style0 from "./client-upload.vue?vue&type=style&index=0&id=3a9eb485&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports